import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import PageNextJs from 'nextjs/PageNextJs';

const Contact = dynamic(() => import('ui/pages/Contact'), { ssr: false });

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/contact">
      <Contact/>
    </PageNextJs>
  );
};

export default Page;
